import React from 'react'
import { BodyText, H3 } from 'src/branding/typography'
import { Center } from 'src/components/styled/FlexBox'
import styled from 'styled-components'

const Container = styled(Center)`
  flex-direction: column;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.colours.mayoWhite} !important;
  height: 380px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  > span {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    max-width: 650px;
  }
`

const TooMuchData = () => {
  return (
    <Container>
      <H3>Too Much Data to Handle!</H3>
      <BodyText>
        Looks like your search is a bit too broad for us to fetch right now. Try
        narrowing your filters and/or date and give it another go, we’ll be
        ready!
      </BodyText>
    </Container>
  )
}

export default TooMuchData
